<div class="circle cursor-pointer no-select">
  <web-design-system-icon name="chevron" [class.icon-rotate]="!isCollapsed" />
</div>
